import { Fragment } from "react";
import BoxIcon from "../../../icons/boxIcon";
import ContainerCard from "./containerCard";
import { useTranslation } from "react-i18next";
const containers = [
  {
    img: "/assets/20feet.png",
    name: "20 FT",
    internal: "5.9 x 2.35 x 2.39 m",
    doorMeasurement: "2.34 x 2.28 m",
    loadingCapacity: "~33 m³",
    emptyWeight: "~28,200 kg",
    maxLoad: "~28.280 tons",
  },
  {
    img: "/assets/40feet.png",
    name: "40 FT",
    internal: "12.03 x 2.35 x 2.39 m",
    doorMeasurement: "2.34 x 2.28 m",
    loadingCapacity: "~33 m³",
    emptyWeight: "~3.740 ton",
    maxLoad: "~28.280 tons",
  },
  {
    img: "/assets/20OpenRoof.png",
    name: "20 feet - Open Roof",
    internal: "5.89 x 2.35 x 2.34 m",
    doorMeasurement: "2.34 x 2.28 m",
    loadingCapacity: "~32.5 m³",
    emptyWeight: "~2.380 tons",
    maxLoad: "~28.100 tons",
    roofOpen: "5.68 x 2.25 m",
  },
  {
    img: "/assets/40OpenRoof.png",
    name: "40 feet - Open Roof",
    internal: "12.02 x 2.35 x 2.34 m",
    doorMeasurement: "2.34 x 2.28 m",
    loadingCapacity: "~66.3 m³",
    emptyWeight: "~3.880 tons",
    maxLoad: "~28.600 tons",
    roofOpen: "11.79 x 2.23 m",
  },
  {
    img: "/assets/40feet.png",
    name: "40 feet _ high (high cube)",
    internal: "12.3 x 2.35 x 2.69 m",
    doorMeasurement: "2.34 x 2.58 m",
    loadingCapacity: "~76.2 m³",
    emptyWeight: "~3.830 tons",
    maxLoad: "26.650 / 28.670 tons",
  },
  {
    img: "/assets/20NoSides.png",
    name: "20 feet - without sides",
    internal: "5.65 x 2.43 x 2.21 m",
    doorMeasurement: "6.05 x 2.43 x 2.59 m",
    loadingCapacity: "~28.4 m³",
    emptyWeight: "~3.050 tons",
    maxLoad: "~30.950 tons",
  },
  {
    img: "/assets/40NoSides.png",
    name: "40 feet - without sides",
    internal: "12.8 x 2.43 x 1.95 m",
    doorMeasurement: "12.19 x 2.43 x 2.59 m",
    loadingCapacity: "~53.2 m³",
    emptyWeight: "6.200 tons",
    maxLoad: "~38.800 tons",
  },
  {
    img: "/assets/20feet.png",
    name: "20-foot refrigerated container",
    internal: "5.45 x 2.28 x 2.26 m",
    outer: "6.05 x 2.43 x 2.59 m",
    doorMeasurement: "2.29 x 2.22 m",
    loadingCapacity: "~28.2 m³",
    emptyWeight: "~2.910 tons",
    maxLoad: "~27.570 tons",
  },
  {
    img: "/assets/20feet.png",
    name: "40 foot refrigerated container",
    internal: "11.59 x 2.28 x 2.54 m",
    outer: "12.19 x 2.43 x 2.89 m",
    doorMeasurement: "2.29 x 2.50 m",
    loadingCapacity: "~67.5 m³",
    emptyWeight: "4.520 tons",
    maxLoad: "~29.480 tons",
  },
];
const ContainerTypes = () => {
  const { t } = useTranslation();
  return (
    <main>
      <article className="py-20">
        <div className="w-11/12 mx-auto">
          <span className="block mx-auto w-fit">
            <BoxIcon className={"size-[60px]"} />
          </span>
          <h1 className="text-[24px] my-5 md:text-[32px] font-bold text-mainBlue text-center">
            {t("containerTypes")}
          </h1>
          <p className="mx-auto my-10 text-lg text-center text-mainGray">
            {/* {t("customsTariffsAreImposedByCountries")} */}
            {t("containersAreUsed")}
          </p>
          <section className="grid grid-cols-1 gap-5 md:grid-cols-2">
            {containers.map((container, i) => (
              <Fragment key={i}>
                <ContainerCard container={container} />
              </Fragment>
            ))}
          </section>
        </div>
      </article>
    </main>
  );
};

export default ContainerTypes;
